import { ValidBusinessObject } from '@iotv/iotv-v3-types'
import { AlertType, GeofenceRuleDecisionType, MetricRuleDecisionType, OutcomeType, type BooleanRuleDecisionType } from '../ModelClassInterfaces'
import { AlertStateusKeys, AlertStatus, UserAttributeDefs } from '../types/ModelTypes'
import { ModelCommon } from './ModelCommon'
import { ThingShadowState } from './ThingShadowState'

const debug = !process.env.AWS_SESSION_TOKEN && false

const typeName = 'Alert'

class Alert extends ModelCommon implements AlertType {
  //currently can't inhertit from Thing as constructor just expects ob. A consequence of 'can't user prototype.constructor.name in Webpack'
  // thing?: Horse;
  // shadow?: ThingShadowState;
  // timestamp?: string
  // summary?: string;
  // alerts?: { [k:string]: any};
  // decisionState?: { [k:string]: any};
  // _state?: string

  constructor(ob: any) {
    super(typeName, ob)
  }

  thing?: ValidBusinessObject
  shadow?: ThingShadowState
  timestamp?: number
  summary?: string
  alerts?: {
    [k in OutcomeType]: (BooleanRuleDecisionType | MetricRuleDecisionType | GeofenceRuleDecisionType)[]
  }
  decisionState?: { [k: string]: OutcomeType }
  _state?: string

  get alertStatus(): AlertStatus {
    return {
      NOT_SET: 'NOT_SET',
      NO_ALERT: 'NO_ALERT',
      ISSUED_NO_ACK: 'ISSUED_PENDING_ACKNOWLDGED',
      ISSUED_ACKNOWLEDGED: 'ISSUED_ACKNOWLEDGED',
      RESOLVED: 'RESOLVED',
      CANCELLED: 'CANCELLED',
    }
  }

  getAlertStatusKey(keyIn: string) {
    const keys: AlertStateusKeys[] = Object.keys(this.alertStatus) as AlertStateusKeys[]
    return keys.find((key) => keyIn === this.alertStatus[key])
  }

  get state() {
    return this._state
  }

  set state(newState) {
    console.log('In setter for state on Alert')
    if (newState && Object.keys(this.alertStatus).includes(newState)) {
      this._state = newState
    } else {
      console.log(`${newState} is not valide on Alert ${this.name}`)
    }
  }

  getUserAttributes(): UserAttributeDefs {
    const statusLabel = 'Alert Status'
    let atts: UserAttributeDefs = {
      description: undefined,
      ...super.getUserAttributes(),
      name: {
        //override validation
        type: 'String',
      },
      summary: {
        type: 'String',
      },
      timestamp: {
        type: 'Date',
        displayFn: (timestamp: number) => new Date(timestamp * 1000).toString(),
      },
      state: {
        type: 'Derived',
        valueFn: (state: any, functions: { [k: string]: Function; dispatchAction: Function }, accessKey: string) => {
          debug && console.log('Alert Status  gets', { functions, accessKey })
          return {
            currentValue: this.state,
            possibleValues: this.alertStatus,
            setValue: (e: any) => this.handleAlertStatusChange(functions, e, accessKey),
            accessKey,
            label: statusLabel,
          }
        },
        viewName: 'EnumSelect',
      },
    }
    delete atts.description
    return atts
  }

  getLinkAttributes() {
    return this.getUserAttributes()
  }
}

export { Alert }
